export default __webpack_public_path__ + "static/media/lara.0d9b7360.png";